import { useEffect, useState } from "react"
import { CatchWrapperAsync } from "../utils/catchwrapper"
import AxiosFetchData from "../pages/AxiosFetchData"
import { useNavigate,useParams } from "react-router-dom"
import Helper from "../pages/Helper"
import ConfirmationButton from "../components/ConfirmationButton"
import { PermCameraMicSharp } from "@mui/icons-material"
export const useMomHook = () =>{
    const [message,setmessage] = useState('')
    const [typeError,setTypeError] = useState('')
    const [momMonth,setMomMonth] = useState(1)
    const [momYear,setMomYear] = useState(2026)
    const [momWeek,setMomWeek] = useState(1)
    const [roles,setRole] = useState(null)
     const [rolesAccess,setRoleAccess] = useState(null)
    const [find,setFind] = useState('')
    const [rows,setRows] = useState([])
     const [updateId,setUpdateId] = useState({})
    const [openAdd,setOpenAdd] = useState(false)
    const [openEdit,setOpenEdit] = useState(false)
    const [toggle,setToggle] = useState(true)

    const navigate = useNavigate()
    const { id } = useParams();
    useEffect(()=>{
        GetPeriode()
        
    },[id])

    const currentYear = parseInt((Helper.GetDateDDMMYYYY(new Date()).split("/")[2]))
        
    let yearList =[]

    for(let i= (currentYear - 3);i < currentYear ;i++){
                let year = {
                    label : i + " - " + i,
                    value : i
                }
                yearList.push(year)
    }

    yearList.push({
            label : currentYear + " - " + currentYear,
            value : currentYear
    })

   
    const weekList = [
        {
            value :1,
            label : 1,
        },
         {
            value :2,
            label : 2,
        },
         {
            value :3,
            label : 3,
        },
         {
            value :4,
            label : 4,
        },
         {
            value :5,
            label : 5,
        },
         {
            value :6,
            label : 6,
        },
    ]

    const monthList = [ {
        value : 1,
        label : "1 - January"
    },{
        value : 2,
        label : "2 - February"
    },{
        value : 3,
        label : "3 - March"
    },{
        value : 4,
        label : "4 - April"
    },{
        value : 5,
        label : "5 - May"
    },{
        value : 6,
        label : "6 - June"
    },{
        value : 7,
        label : "7 - July"
    },{
        value : 8,
        label : "8 - August"
    },
    {
        value : 9,
        label : "9 - September"
    },{
        value : 10,
        label : "10 - October"
    },{
        value : 11,
        label : "11 - November"
    },{
        value : 12,
        label : "12 - December"
    },]

      //  setYearList(yearList)

    const GetPeriode = async () =>{
        CatchWrapperAsync(async ()=>{
            const periode = await AxiosFetchData.get(`GetMomPeriode`).refreshToken(navigate,'mom')
            setMomMonth(periode.data[0].months)
            setMomYear(periode.data[0].years)
            setMomWeek(periode.data[0].week)
            setRole(periode.decode)
            setRoleAccess(periode.roleaccess)
            console.log(periode)
            fetchData(periode.data[0].week,periode.data[0].months,periode.data[0].years)
        },setmessage,setTypeError)
    }

    const fetchData = async (week,bulan,tahun) => {
        var data = {
            week : week,
            tahun : tahun,
            bulan : bulan,
            type : id
        }
        const response = await AxiosFetchData.post(`GetAllMom`, data).refreshToken(navigate,'mom')
      //  console.log(response.data)
        setRows(response.data)
    }

    const columns = [
                { field: 'rowNumber', headerName: 'No.', width: 80 },
                // { field: 'tanggal', headerName: 'Tanggal', width: 200, valueGetter: (value) => {
                //    return Helper.GetDateDDMMYYYY(value.row.tanggal);
                //   }  },
                 { field: 'project_alias', headerName: 'Project', width: 200},
                { field: 'progress', headerName: 'Progress', width: 250 },
               {
                    field: 'detail',
                    headerName: 'Detail',
                    width: 200,
                    sortable: false,
                    renderCell: (params) => (
                      <>
                          <div dangerouslySetInnerHTML={{ __html: params.row.detail }} />
                      </>
                    ),
                },
                // { field: 'jumlah', headerName: 'Jumlah', width: 150 },
                // { field: 'satuan', headerName: 'Satuan', width: 150 },
              
                {
                    field: 'plan',
                    headerName: 'Plan',
                    width: 200,
                    sortable: false,
                    renderCell: (params) => (
                      <>
                          <div dangerouslySetInnerHTML={{ __html: params.row.plan }} />
                      </>
                    ),
                },
                // { field: 'user', headerName: 'User', width: 200,sortable: false,  valueGetter: (value) => {
                //    return  resourceRows.filter((item) => item.id == value.row.resource_id)[0].nama_client;
             
                {
                    field: 'target',
                    headerName: 'Target',
                    width: 200,
                    sortable: false,
                    renderCell: (params) => (
                      <>
                          <div dangerouslySetInnerHTML={{ __html: params.row.target }} />
                      </>
                    ),
                },
                { field: 'due_date', headerName: 'Due Date', width: 200 },
                { field: 'pic', headerName: 'PIC', width: 200 },
                {
                    field: 'actions',
                    headerName: 'Actions',
                    width: 150,
                    sortable: false,
                    renderCell: (params) => (
                      <>
                        <button
                          onClick={() => {
                            //setConfirmEditOpen(true)
                            setOpenEdit(true)
                            setUpdateId(params.row.id)
                           // setData(params.row)
                          }}  
                          className="btn btn-primary mr-2 btn-sm"
                          disabled={!rolesAccess.UPDATE}
                        >
                          Edit
                        </button>
                    
                      <ConfirmationButton classname='btn btn-danger btn-sm' text="Do you want delete this data?" type="button" 
                       disabled={!rolesAccess.DELETE} 
                       onClick={() => handleDelete(params.row.id)}
                      >
                            Delete 
                      </ConfirmationButton>
                    
                      </>
                    ),
                },
                
            ];

    const handleDelete = (id) => {
        setRows((prev)=>prev.filter((item) => item.id != id))
    }

    const handleSave = async () => {
        if(rows.length == 0){
            setmessage("M.O.M is empty")
            setTypeError("error")
            return;
        }

        var data= {
            minggu : momWeek,
            bulan : momMonth,
            tahun : momYear,
            rows : rows,
        }

        CatchWrapperAsync(async ()=>{
             await AxiosFetchData.post(`SaveMom`,data).refreshToken(navigate,"projectse")
             await fetchData(momWeek,momMonth,momYear)
        },setmessage,setTypeError)
        
    }

    return {message,setmessage,typeError,setTypeError,momMonth,setMomMonth,momYear,setMomYear,momWeek,setMomWeek,
        yearList,monthList,weekList,setFind,find,rows,columns,openAdd,setOpenAdd,openEdit,setOpenEdit,setRows,handleSave,
        navigate,fetchData,updateId,toggle,setToggle,rolesAccess
    }
}

 